import styled from 'styled-components';

export const Decoration = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

export const Floor = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;

  &.floor-1 {
    > img.left {
      width: 313px;
    }
    > img.right {
      width: 313px;
    }
  }

  &.floor-2 {
    > img.left {
      width: 319px;
    }
    > img.right {
      width: 319px;
    }
  }

  &.floor-3 {
    > img.left {
      width: 319px;
    }
    > img.right {
      width: 319px;
    }
  }

  &.floor4 {
    > .img.left {
      width: 159px;
    }
    > .img-right {
      width: 159px;
    }
  }
`;
